import ReactDOM from "react-dom"
import App from "./app"

const appRoot = document.getElementById("capioweb")
const renderMethod = module.hot ? ReactDOM.render : ReactDOM.hydrate

if (appRoot) {
	renderMethod(<App />, appRoot)
}
